import avatar from '@/assets/avatar/avatar.svg';
import biaoqing from '@/assets/avatar/biaoqing.svg';
import dianshiji from '@/assets/avatar/dianshiji.svg';
import diqiuyi from '@/assets/avatar/diqiuyi.svg';
import gaoreliang from '@/assets/avatar/gaoreliang.svg';
import jinritemai from '@/assets/avatar/jinritemai.svg';
import lipin from '@/assets/avatar/lipin.svg';
import meishi from '@/assets/avatar/meishi.svg';
import naozhong from '@/assets/avatar/naozhong.svg';
import ningmeng from '@/assets/avatar/ningmeng.svg';
import qiche from '@/assets/avatar/qiche.svg';
import reqiqiu from '@/assets/avatar/reqiqiu.svg';
import shaokao from '@/assets/avatar/shaokao.svg';
import shuiguo from '@/assets/avatar/shuiguo.svg';
import sushi from '@/assets/avatar/sushi.svg';
import tianpin from '@/assets/avatar/tianpin.svg';
import yinliao from '@/assets/avatar/yinliao.svg';
import zhiwu from '@/assets/avatar/zhiwu.svg';
import zhunshida from '@/assets/avatar/zhunshida.svg';
import ghost from '@/assets/avatar/ghost.svg';

export default {
  avatar,
  biaoqing,
  dianshiji,
  diqiuyi,
  gaoreliang,
  jinritemai,
  lipin,
  meishi,
  naozhong,
  ningmeng,
  qiche,
  reqiqiu,
  shaokao,
  shuiguo,
  sushi,
  tianpin,
  yinliao,
  zhiwu,
  zhunshida,
  ghost,
}